<!--  -->
<template>
  <div class="boxr">
    <div style="margin-bottom:10px">
      <el-input
        v-model="pageIfon.keywords"
        style="width:200px;margin-right:10px"
        placeholder="请输入公众号名称/appid"
      />
      <!-- <el-input v-model="pageIfon.app_id" style="width:200px;margin-right:10px" placeholder="请输入appid" /> -->
      <el-select
        v-model="pageIfon.onlyMe"
        placeholder="请选择"
        style="margin-right:20px"
      >
        <el-option
          v-for="item in accountarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button
        type="primary"
        @click="search"
      >搜索</el-button>
    </div>

    <el-table
      :data="imgarrs"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="account_name"
        label="公众号名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="公众号appid"
        width="180"
        align="center"
      />
      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            style="margin-bottom:10px"
            @click="choose(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { listForTimingArticles } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      imgarrs: [],
      total: null,
      pageIfon: {
        page: 1,
        pageSize: 10,
        keywords: null,
        onlyMe: 2,
        platform_id: null,
        msg_no: null
      },
      accountarr: [
        {
          value: 1,
          label: '查看组内公众号'
        },
        {
          value: 2,
          label: '我关联的公众号'
        }
      ]
    }
  },
  created() {
    // this.acounewlist()
  },
  mounted() {},
  methods: {
    async acounewlist() {
      const data = await listForTimingArticles(this.pageIfon)
      this.imgarrs = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.acounewlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.acounewlist()
    },
    send(id, msg_no) {
      this.pageIfon.platform_id = id
      this.pageIfon.msg_no = msg_no
      this.acounewlist()
    },
    choose(item) {
      console.log('item', item)
      this.$emit('callbackr', item)
    },
    search() {
      this.pageIfon.page = 1
      this.acounewlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.boxr {
  padding: 20px;
}
</style>
